import { forwardRef } from "react";
import { bool, func, string } from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";

/**
 * @component Transition
 * @returns {JSX.Element}
 */
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * @component DialogHelp
 * @param {Object} props
 * @param {boolean} props.open
 * @param {string} props.title
 * @param {string} props.content
 * @param {function} props.onClose
 * @returns {JSX.Element}
 */
const DialogHelp = ({
  open,
  title,
  content,
  onClose,
  onCloseButtonText = "Close",
  onSave = undefined,
  onSaveButtonText = "Confirm",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={onClose}>{onCloseButtonText}</Button>
		{onSave && <Button variant="contained" color="primary" onClick={onSave}>{onSaveButtonText}</Button>}
      </DialogActions>
    </Dialog>
  );
};

DialogHelp.propTypes = {
  open: bool,
  title: string,
  content: string,
  onClose: func,
};

export default DialogHelp;
